(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/views/coupon_header.js') >= 0) return;  svs.modules.push('/modules/matchen/views/coupon_header.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.matchen=_svs.matchen||{};
_svs.matchen.templates=_svs.matchen.templates||{};
svs.matchen.templates.coupon_header = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div translate=\"no\" class=\"event-name-item overflow-threedots align-right\">"
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"match") : depth0)) != null ? lookupProperty(stack1,"participants") : stack1)) != null ? lookupProperty(stack1,"0") : stack1)) != null ? lookupProperty(stack1,"mediumName") : stack1), depth0))
    + "</div>\n<div class=\"event-name-divider\">-</div>\n<div translate=\"no\" class=\"event-name-item overflow-threedots align-left\">"
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"match") : depth0)) != null ? lookupProperty(stack1,"participants") : stack1)) != null ? lookupProperty(stack1,"1") : stack1)) != null ? lookupProperty(stack1,"mediumName") : stack1), depth0))
    + "</div>\n";
},"useData":true});
Handlebars.partials['svs-matchen-coupon_header'] = svs.matchen.templates.coupon_header;
})(svs, Handlebars);


 })(window);